import type { Logger } from "pino";
import { createBrowserLogger } from "./implementations/browser.js";
import type { LogInterceptor, LoggingEnvironment, RootLoggerType } from "./types.js";

export type { Logger } from "pino";
export * from "./pinoModules.js";
export * from "./types.js";
export const ChildLoggers: Map<string, Logger> = new Map();
/**
 * The logging environment for this entry. Imported automatically by Vite instead of the index.ts
 */
export const ActiveLoggingEnvironment: LoggingEnvironment = "browser";

/**
 * The main logger shared by all Verdi packages in browser bundles.
 */
export const RootLogger: RootLoggerType<string> = createBrowserLogger<string>();

export function interceptLogOutput(_fn: LogInterceptor): () => void {
    throw new Error(
        'interceptLogOutput is not supported in the "browser" logging environment — ' +
            'it requires the test implementation (NODE_ENV === "test")',
    );
}
